import { loadHistoryState } from '~/Router/loadHistoryState';
import { useRouter } from '~/Router/useRouter';
export var useBacklink = function () {
    var redirect = useRouter()[0];
    return function (fallback) {
        var state = loadHistoryState();
        if ((state === null || state === void 0 ? void 0 : state.backlink) !== undefined) {
            redirect(state.backlink, undefined, true);
        }
        else {
            fallback();
        }
    };
};
